import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { cn } from "../lib/utils";
import {
  MessageSquare,
  Plug,
  Network,
  User,
  Brain,
  LogOut,
  LifeBuoy,
  Book,
  BarChart3,
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import MarkbaseLogo from "../assets/general/markbase-logo.png";
import MarkbaseLogoWhite from "../assets/general/markbase-logo-white.png";
import OnboardingModal from "../components/modals/onboarding-modal/OnboardingModal.jsx";
import { useProfileSetup } from "../contexts/ProfileContext";

const sidebarTopLinks = [
  { to: "/", icon: MessageSquare, label: "Chat" },
  // { to: "/plugins", icon: Plug, label: "Plugins" },
  { to: "/channels", icon: Network, label: "Channels" },
  { to: "/reports", icon: BarChart3, label: "Reports" },
];

const sidebarBottomLinks = [
  { to: "/account", icon: User, label: "Account" },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

    const {userRole} = useProfileSetup();

  const visibleTopLinks = React.useMemo(() => {
    const links = [...sidebarTopLinks];
    if (userRole === 'admin' || userRole === 'superadmin') {
      links.push({ to: "/admin", icon: Brain, label: "Admin" });
    }
    
    return links;
  }, [userRole]);

  return (
    <div className="flex h-full flex-col gap-4 p-6">
      <div className="flex h-14 items-left">
        {/* Light mode logo - visible by default, hidden in dark mode */}
      <img src={MarkbaseLogo} alt="MarkBase" className="w-full dark:hidden" />
      
      {/* Dark mode logo - hidden by default, visible in dark mode */}
      <img src={MarkbaseLogoWhite} alt="MarkBase" className="w-full hidden dark:block" />
    </div>
      {/* Positioned at the top */}
      <div className="flex-1 space-y-1">
        {visibleTopLinks.map(({ to, icon: Icon, label }) => {
          const isActive = location.pathname === to;
          return (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 rounded-lg px-3 py-2 text-primary transition-all hover:bg-accent hover:text-primary",
                  isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground"
                )
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          );
        })}
      </div>


      {/*Positioned at the Middle*/}
        <div className="flex justify-center">
        <OnboardingModal/>
        </div>

        
      {/* Positioned at the bottom */}
      <div className="flex-2 border-b border-border pb-1">
        {sidebarBottomLinks.map(({ to, icon: Icon, label }) => {
          const isActive = location.pathname === to;
          return (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 rounded-lg px-3 py-2 text-primary transition-all hover:bg-accent hover:text-primary",
                  isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground"
                )
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          );
        })}
        <NavLink
          to="/user-guide"
          className={({ isActive }) =>
            cn(
              "flex items-center gap-3 rounded-lg px-3 py-2 text-primary transition-all hover:bg-accent hover:text-primary",
              isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground"
            )
          }
        >
          <Book className="h-4 w-4" />
          User Guide
        </NavLink>
        <a
          href="https://markbase.ai/support/"
          target="_blank"
          rel="noopener noreferrer"
          className={cn(
            "flex items-center gap-3 rounded-lg px-3 py-2 text-primary transition-all hover:bg-accent text-muted-foreground hover:text-primary"
          )}
        >
          <LifeBuoy className="h-4 w-4" />
          Support
        </a>
      </div>
      <button
        onClick={async () => {
          await logout();
          navigate("/login");
        }}
        className={cn(
          "flex items-center gap-3 rounded-lg px-4 py-2 m text-primary transition-all hover:bg-accent text-muted-foreground hover:text-primary"
        )}
      >
        <LogOut className="h-4 w-4" />
        Logout
      </button>
    </div>
  );
}
